import CalendarDialog, { CalendarDialogProps } from "./CalendarDialog";

export default CalendarDialog;

export type {
  CalendarDialogProps,
};
